/* 周瑜傳・第 1 章：歷陽（興平二年，195）
 * 長江橫在地圖南邊，北岸是歷陽一帶。周瑜從丹楊帶兵、船糧渡江，在東邊上岸，沿內陸的大路往西到歷陽與孫策會合。
 * 劉繇的兩處江防在江邊：當利口（東）、橫江津（西），各有一條小路接上大路。 */
export const START = [7500, 1500], LIYANG = [1300, 2000], DANGLI = [5400, 3200], HENGJIANG = [3000, 3200];
export const SPURS = [[5100, 1380], [2650, 1700]]; // 兩條小路接上大路的路口（當利、橫江）
export default {
  id: 'zhouyu_liyang', name: '歷陽', W: 8400, H: 4800, seed: 1951,
  bases: [START, LIYANG],
  rivers: [{ pts: [[-100, 4200], [3000, 4150], [6000, 4230], [8500, 4180]], hw: 560, fords: [] }],
  roads: [
    { pts: [START, [6200, 1300], SPURS[0], [3800, 1550], SPURS[1], [1900, 1850], LIYANG], w: 140 },
    { pts: [SPURS[0], [5300, 2300], DANGLI], w: 110 },
    { pts: [SPURS[1], [2800, 2400], HENGJIANG], w: 110 },
  ],
  rocks: [[4200, 2500, 360, 180], [6600, 2600, 380, 170], [1500, 3200, 340, 170], [3900, 600, 380, 160], [7300, 600, 300, 150]],
  woods: 0.45,
  sight: 0.8,
  clearings: [[START[0], START[1], 380], [LIYANG[0], LIYANG[1], 560], [DANGLI[0], DANGLI[1], 480], [HENGJIANG[0], HENGJIANG[1], 480]],
  tents: [
    { x: LIYANG[0], y: LIYANG[1], n: 7, r: 420, chief: true, col: '#b8433a', flag: '孫' },
    { x: DANGLI[0], y: DANGLI[1] - 40, n: 6, r: 380, chief: true, col: '#5d6a78', flag: '劉' },
    { x: HENGJIANG[0], y: HENGJIANG[1] - 40, n: 6, r: 380, chief: true, col: '#5d6a78', flag: '劉' },
  ],
  grass: [[4600, 1250, 220, 90], [3300, 1900, 220, 90], [6000, 1650, 200, 90]],
};
